import styled from "styled-components";

export const Icon = styled.img`
  width: 36px;
  height: 36px;
  margin: 0 16px;
`;
